import React from 'react'
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'

import Logo from '../imgs/logo.png'

const styles = theme => ({
    container: {
        margin: 50,
        padding: 50,
        border: '1px solid grey',
        [theme.breakpoints.down('sm')]: {
            margin: 10,
            padding: 10
        }
    },
    topbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        }
    },
    appbar: {
        margin: '20px 0 0 0'
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'center',
        '&>p': {
            margin: '0 10px',
            color: '#393287',
            fontSize: 17,
            '&>a': {
                color: '#393287',
                textDecoration: 'none',
                fontSize: 17
            }
        },
        '&>p:hover': {
            borderBottom: '2px solid #93c156',
            cursor: 'pointer'
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start'
        }
    },
    line: {
        flexGrow: 1
    },
    bar_item: {
        fontSize: 16,
        fontWeight: 'bold'
    },
    divider: {
        margin: '30px 0'
    },
    bottomBar: {
        textAlign: 'center'
    },
    phone: {
        color: '#393287',
        margin: 10
    },
    email: {
        color: '#393287',
        margin: 10
    },
    copyright: {
        color: '#393287'
    }
})

const Frame = ({classes, children, changePage}) => (
    <div className={classes.container}>
        <div className={classes.topbar}>
            <Typography variant="subheading" className={classes.phone}>510.552.8079</Typography>
            <img src={Logo} />
            <Typography variant="subheading" className={classes.email}>yuanzhe.jane@gmail.com</Typography>
        </div>
        <div className={classes.appbar}>
            <Toolbar className={classes.toolbar}>
                <Divider className={classes.line} />
                <Typography className={classes.bar_item} onClick={() => {changePage('home')}}>HOME</Typography>
                <Typography className={classes.bar_item} onClick={() => {changePage('bath')}}>BATH & KITHEN</Typography>
                <Typography className={classes.bar_item} onClick={() => {changePage('day')}}>ONE-DAY DESIGN</Typography>
                <Typography className={classes.bar_item} onClick={() => {changePage('staging')}}>REAL ESTATE STAGING</Typography>
                <Typography className={classes.bar_item} onClick={() => {changePage('landscaping')}}>LANDSCAPING</Typography>
                <Typography className={classes.bar_item} onClick={() => {changePage('portfolio')}}>PORTFOLIO</Typography>
                <Typography className={classes.bar_item} onClick={() => {changePage('about')}}>ABOUT</Typography>
                <Typography className={classes.bar_item} onClick={() => {changePage('contact')}}>CONTACT</Typography>

                {/* <Typography className={classes.bar_item}><Link to="/">HOME</Link></Typography>
                <Typography className={classes.bar_item}><Link to="/bath">BATH&KITHEN</Link></Typography>
                <Typography className={classes.bar_item}><Link to="/day">ONE-DAY DESIGN</Link></Typography>
                <Typography className={classes.bar_item}><Link to="/staging">REAL ESTATE STAGING</Link></Typography>
                <Typography className={classes.bar_item}><Link to="/landscaping">LANDSCAPING</Link></Typography>
                <Typography className={classes.bar_item}><Link to="/portfolio">PORTFOLIO</Link></Typography>
                <Typography className={classes.bar_item}><Link to="/about">ABOUT</Link></Typography>
                <Typography className={classes.bar_item}><Link to="/contact">CONTACT</Link></Typography> */}
                <Divider className={classes.line} />
            </Toolbar>
        </div>
        {children}
        <Divider className={classes.divider}/>
        <div className={classes.bottomBar}>
            <Typography variant="body1" className={classes.copyright}>Ⓒ Purpleleaf Design 2024</Typography>
        </div>
    </div>
)

export default withStyles(styles)(Frame)